<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before: always;"></div>
<p class="P_Normal__And__Page_Break" id="auto_bookmark_toc_1"><span style=" font-style: italic; font-size: 1.00em;">“You purchase pain with all that joy can give and die of nothing but a rage to live.”</span></p>
<p class="P_Normal">—Alexander Pope, Epistle II: To a Lady</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0005.vue?5e97ff9f